import React from 'react';

const LaboratoryValues = () => {
    return (
        <div className="flex flex-col h-[calc(100vh-64px)] w-full">
            <iframe
                src={require('../../../../assets/pdf/Genio+Lab+Values.pdf')}
                title="Laboratory Values PDF"
                className="flex-1 w-full border-0"
            ></iframe>
        </div>
    )
}

export default LaboratoryValues;